import { Citation } from "../helpers/Models";
import { useQuery } from "@tanstack/react-query";
import { getDocument } from "../api/document";
import { useSessionId } from "./use-session";
import { useAuth } from "@clerk/clerk-react";
import { isRunningInBrowser } from "../components/App";

export interface UseDocumentParams {
  citation: Citation;
}

export const useDocument = ({ citation }: UseDocumentParams) => {
  const { getToken } = useAuth();
  const sessionId = useSessionId();
  const opinionId = citation.opinion_id ?? citation.resource_text ?? citation.text;

  const { data: document, isLoading: loading } = useQuery({
    queryKey: ["document", opinionId],
    queryFn: () => getDocument({ getToken, opinionId, sessionId }),
    enabled: (isRunningInBrowser() || !!sessionId) && !!citation,
  });

  return { document, loading };
};
